function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { getPassStyle } from './helpers/passStyle';
import { PkpassPassStyleTypes } from '../../../types';
export const PkpassContext = /*#__PURE__*/React.createContext({
  pass: {},
  passStyle: PkpassPassStyleTypes.Generic,
  images: {},
  language: 'en',
  scanDisabled: false
});
export function PkpassContextProvider(props) {
  const [state, setState] = React.useState({
    passStyle: getPassStyle(props.pass),
    pass: props.pass,
    images: props.images,
    language: props.language || 'en',
    scanDisabled: props.scanDisabled === true
  });
  React.useEffect(() => {
    setState({
      passStyle: getPassStyle(props.pass),
      pass: props.pass,
      images: props.images,
      language: props.language || 'en',
      scanDisabled: props.scanDisabled === true
    });
  }, [props.pass, props.images, props.language, props.scanDisabled]);

  const context = _objectSpread(_objectSpread({}, state), {}, {
    onFieldDnD: props.onFieldDnD,
    onFieldClick: props.onFieldClick,
    onImageClick: props.onImageClick,
    onBarcodeClick: props.onBarcodeClick,
    onLogoTextClick: props.onLogoTextClick,
    onBoardingPassIconClick: props.onBoardingPassIconClick
  });

  return /*#__PURE__*/React.createElement(PkpassContext.Provider, {
    value: context
  }, props.children);
}
//# sourceMappingURL=PkpassContext.js.map